import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_marketing/about")({
  beforeLoad: () => {
    throw redirect({
      to: "/about-us",
      replace: true,
      statusCode: 301,
    });
  },
});
